/**
 * Creates a configuration object for content settings.
 *
 * @param {number} step - The step value for the spinner.
 * @param {number} max - The maximum allowable value.
 * @param {number} min - The minimum allowable value.
 * @returns {Object} Configuration object with common settings.
 *
 * @property {boolean} spinner - Whether the spinner is enabled (default: false).
 * @property {number} step - The step value for the spinner.
 * @property {string} prefix - The currency prefix (default: "£").
 * @property {number} precision - The precision for values (default: 0).
 * @property {number} max - The maximum allowable value.
 * @property {number} min - The minimum allowable value.
 * @property {string} thousands - The thousands separator (default: ",").
 */
export const createConfigContentCover = (step, max, min) => {
  return {
    spinner: false,
    step,
    prefix: "£",
    precision: 0,
    max,
    min,
    thousands: ",",
  };
};
